export const notifyGuestsOverlayShowing = (state) => state.modals.showNotifyGuestsOverlay;

export const anyOverlayShowing = (state) =>
  // TODO: Need to consolidate any other modals state into redux to make this useful
  state.modals.showNotifyGuestsOverlay || state.loginModal?.showLoginModal;

export const selectUpsellOrder = (state) => state.modals.sectionToRemove;

export const selectIsUpsellConfirmed = (state) => state.modals.upsellConfirmed;
